import { render, staticRenderFns } from "./ActUnlockLimitSupplyNew.vue?vue&type=template&id=06e61b78&scoped=true"
import script from "./ActUnlockLimitSupplyNew.vue?vue&type=script&lang=js"
export * from "./ActUnlockLimitSupplyNew.vue?vue&type=script&lang=js"
import style0 from "./ActUnlockLimitSupplyNew.vue?vue&type=style&index=0&id=06e61b78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e61b78",
  null
  
)

export default component.exports